import emojiRegex from "emoji-regex";


export function getCookie(name) {
  if (!document.cookie) return null;

  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [key, value] = cookie.trim().split('=');
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}

export function isInWebView() {
  const ua = navigator.userAgent || '';
  return (
    /\bwv\b/.test(ua) || // Android WebView
    /FBAN|FBAV|Instagram|Line|Wechat/.test(ua) || // Facebook, Instagram, WeChat
    (/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/.test(ua)) // iOS WebView
  );
}

export const isEmoji = (input) => {
  const regex = emojiRegex();
  return regex.test(input);
};